import { SearchOutlined } from '@ant-design/icons';
import { Select, Space, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { Loader } from 'components/Global';
import Buttons from 'components/Global/Buttons';
import DateRangePickerField from 'components/Global/DateRangePicker';
import SearchComponent from 'components/Global/SearchComponent';
import { DownloadSvg } from 'utils/svgs';
import styles from './index.module.scss';

type Props = {
	searchText: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
	dateRange: [dayjs.Dayjs, dayjs.Dayjs];
	onDateRangeChange: (value: [dayjs.Dayjs, dayjs.Dayjs] | null) => void;
	completionStatus: 'all' | 'completed' | 'pending';
	onCompletionStatusChange: (value: 'all' | 'completed' | 'pending') => void;
	totalRecords: number;
	downloadLoanCsv: any;
	downloadLoading: boolean;
	selectedCount?: number;
	selectedCurrency?: 'ZMW' | 'USD';
	onBulkPayment: () => void;
	selectedPaymentMethod: string;
	setSelectedPaymentMethod: any;
};

const LoanRequestTableHeader = (props: Props) => {
	const {
		searchText,
		handleSearch,
		handleSearchApi,
		dateRange,
		onDateRangeChange,
		completionStatus,
		onCompletionStatusChange,
		totalRecords,
		downloadLoanCsv,
		downloadLoading,
		selectedCount = 0,
		selectedCurrency = 'ZMW',
		onBulkPayment,
		selectedPaymentMethod,
		setSelectedPaymentMethod,
	} = props;
	const bulkPaymentButton = [
		{
			text: `Bulk Payment (${selectedCurrency})`,
			isLoading: false,
			className: 'btn-blue',
			isSubmit: true,
			onclick: onBulkPayment,
			disabled: selectedCount === 0,
		},
	];

	const paymentMethodOptions = [
		{
			label: 'All',
			value: '',
		},
		{
			label: 'Cash',
			value: 'cash',
		},
		{
			label: 'Bank',
			value: 'bank',
		},
	];

	const completionStatusOptions = [
		{ label: 'All loans', value: 'all' },
		{ label: 'Completed loans', value: 'completed' },
		{ label: 'Pending loans', value: 'pending' },
	];

	return (
		<div className={styles['loan-request-header']}>
			<Space>
				<SearchComponent
					className={styles['loan-request-header-item']}
					placeHolder="Search by code or name"
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={handleSearchApi}
					value={searchText}
					size="large"
				/>
				<DateRangePickerField
					name="dateRangeFilter"
					value={dateRange as unknown as string}
					required={false}
					isError={false}
					onChange={(value) => {
						onDateRangeChange(
							(value as unknown) as [dayjs.Dayjs, dayjs.Dayjs] | null
						);
					}}
				/>
				<Select
					className={styles['loan-request-header-item']}
					value={completionStatus}
					options={completionStatusOptions}
					onChange={onCompletionStatusChange}
					size="large"
					placeholder="Completion status"
					style={{ maxWidth: '180px' }}
				/>
				<Select
					className={styles['loan-request-header-item']}
					value={selectedPaymentMethod}
					options={paymentMethodOptions}
					onChange={(value) => {
						setSelectedPaymentMethod(value);
					}}
					size="large"
					placeholder="Select payment Method"
					style={{
						maxWidth: '200px',
					}}
				/>
			</Space>
			<div className={styles['loan-request-header__buttons']}>
				{selectedCount > 1 && (
					<>
						<div style={{ marginRight: '10px' }}>
							<Buttons buttons={bulkPaymentButton} />
						</div>
					</>
				)}
				{/* {bulkPaymentVisible && <Buttons buttons={headerButtons} />} */}
				{totalRecords > 0 ? (
					<div
						style={{
							marginRight: '10px',
						}}
					>
						<Tooltip title="Download Excel with loan Data">
							<p
								className={styles['csv-button']}
								onClick={
									!downloadLoading
										? downloadLoanCsv
										: undefined
								}
							>
								{downloadLoading ? (
									<>
										<Loader />
									</>
								) : (
									<DownloadSvg />
								)}
							</p>
						</Tooltip>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default LoanRequestTableHeader;
